import React, { useMemo, Fragment } from 'react';
import { PRODUCT_INFO, INTAKE, PATIENT } from '../../../constants/patientChart.constant';
import useCmnTemplate from '../../../hooks/useCmnTemplate';

export const CMNUI = ({
  orderId = 0,
  patientId = 0,
  doctorId = 0,
  product = PRODUCT_INFO(),
  patient = PATIENT(),
  intake = INTAKE(),
  medicalOrderNotes = {},
  formField = {},
  history = {},

  getCmnPdfData = async (requestBody = {}) => {},
  setFormField = () => {},
}) => {
  const { template: tN, Template, id } = useCmnTemplate({ product, patient });

  const TemplateCollection = useMemo(() => new Map([
    [false, Fragment],
    [true, Template],
  ]), [Template]);

  const templateProps = useMemo(() => new Map([
    [false, {}],
    [true, {
      id,
      orderId,
      patientId,
      doctorId,
      productInfo: product,
      patientInfo: patient,
      consultInfo: intake,
      notes: { medicalOrderNotes },
      history,
      formField,
      setFormField,
      getCmnPdfData,
    }]
  ]), [Template, orderId, patientId, doctorId, product, patient, intake, history, medicalOrderNotes, formField]);

  const UI = TemplateCollection.get(!!tN);

  return (
    <UI {...templateProps.get(!!tN)} />
  );
};

export default CMNUI;
